import { inject, observer } from "mobx-react";
import * as React from 'react';
import { WellsStore } from "src/Stores/Wells/WellsStore";

@inject('stores')
@observer
export class WellFooter extends React.Component {
    public props: any;
    public WellsStore: WellsStore;

    constructor(props: any) {
        super(props);
        this.WellsStore = props.stores.WellsStore;
    }

    public render() {
        const well = this.WellsStore.well;
        if (well) {
            return (
                <div className="footer-content">
                    <span>
                        Well: {well && well.wellName} -- {well && well.contractor && well.contractor.contractorName} -- {well && well.rigNumber}
                    </span>
                </div>
            );
        }

        return '';
    }
}

export default WellFooter;


// WEBPACK FOOTER //
// ./src/Components/Footer/WellFooter.tsx